import React from 'react'
import {ShieldCheck} from 'lucide-react'

function Guarantee() {
  return (
    <section className="bg-[#FCFAF5] py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="bg-white rounded-[20px] border border-[#EBD9C3] p-10 md:p-16 flex flex-col md:flex-row items-center gap-10 shadow-sm animate-fade-up">
          <div className="flex-shrink-0">
            <div className="w-36 h-36 md:w-[9.5rem] md:h-[9.5rem] rounded-full bg-[#EBD9C3] flex items-center justify-center shadow-inner">
              <ShieldCheck className="w-16 h-16 md:w-[4.5rem] md:h-[4.5rem] text-[#D9891B]" />
            </div>
          </div>
          <div className="text-center md:text-left">
            <h3 className="font-display text-2xl md:text-4xl font-bold text-[#49352B] mb-3">
              Garantia incondicional de <span className="text-[#D9891B]">7 dias</span>
            </h3>
            <p className="text-[#49352B]/70 text-lg leading-relaxed mb-3">
              Faça suas primeiras receitas. Se elas não superarem suas expectativas, basta enviar
              uma mensagem e devolvemos 100% do seu dinheiro.
            </p>
            <p className="text-[#5E774B] font-semibold">Sem perguntas. Sem burocracia.</p>
            <p className="text-[#49352B]/70 mt-2">Você assume zero risco. Todo o risco fica por nossa conta.</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Guarantee
